import Axios from "axios";
import { message } from "antd";

import * as AlertUtils from "../../Utils/alertUtils";

export default function postCodeFetch(postCode, setAddSuggData) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/address-lookup`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        postcode: postCode,
      },
    })
      .then((response) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
        setAddSuggData(response?.data?.suggestions);
      })
      .catch((err) => {
        message.error("Something Went Wrong ! Connect to Admin Support");
        dispatch({
          type: "Loading",
          payload: false,
        });
      });
  };
}
